import {
  CustomTabList,
  SectionCard,
  SectionCardSubTitle,
  SectionCardTitle,
} from "@/components";
import { Tabs, TabsContent } from "@/components/ui";
import { tabs } from "./const";
import { Blogs } from "./Blogs";
import { Gallery } from "./Gallery";

const UpdatesInfo = () => {
  return (
    <section className="bg-[#F9F9F9]">
      <SectionCard className="flex flex-col items-center justify-center">
        
        <Tabs defaultValue="2" className="mt-6 flex items-center">
          {/* <CustomTabList tabs={tabs}/> */}
          
          <TabsContent value="2">    
            <Blogs />           
          </TabsContent>
        </Tabs>
      </SectionCard>
    </section>
  );
};

export default UpdatesInfo;
